<template>
  <div class="d-flex flex-column justify-center loginContainer">
    <v-btn
      class="loading-button"
      fab
      :loading="loading"
      v-if="loading"

    ></v-btn>
    <v-card
      v-if="!loading"
      class="mx-auto"
      max-width="1440"
      outlined
      min-width="70%"
    >
      <div class="d-flex align-center justify-center titleClassrooms" >
        <v-icon color="white">  mdi-book-search-outline  </v-icon>
        <b>CLASES - testing</b>
      </div>

      <v-list dense >
        <v-list-item-group
          value="selectedClassroom"
          color="primary"
        >
          <v-list-item
            class="clasroomsList"
            v-for="(item, i) in classrooms"
            :key="i"
            @click="showClassroom(item.id)"
          >

            <!-- <v-list-item-icon>
              <v-icon v-text="item.icon"></v-icon>
            </v-list-item-icon> -->
            <v-btn
              small
              color="#34417C"
              dark
              class="buttonClassId"
            >
              {{item.id}}
            </v-btn>
            <v-list-item-content>
              <b>{{item.name}}</b>

            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-card>
  </div>
</template>

<script>
  import { CLASSROOM_REQUEST } from '@/store/actions/user'
  export default {
    created () {
      this.loading = true
      if (!this.classrooms) {
        this.$store.dispatch(CLASSROOM_REQUEST).then((data) => {
          console.log('Lista de clases actualizada')
          this.loading = false
        }, (error) => { // Failure
          console.log('Error en Lista de clases')
          console.log({error})
        })
      } else this.loading = false
    },
    computed: {
      classrooms () {
        return this.$store.state.user.classrooms
      },
      selectedClassroom () {
        return this.$store.state.user.selectedClassroom || ''
      }
    },
    data: () => ({
      loading: false
    }),
    methods: {
      showClassroom: function (classId) {
        console.log(classId)
        this.$router.push({ name: 'agendaForm', params: { classId } })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/classroomList.vue